import type { SxProps, Theme } from '../../themes/themes';
import { DEFAULT_MARGIN_NORMAL, DEFAULT_MARGIN_TEXT } from '../Spacer/Spacer';

export const getStyles = (
  { direction }: { size: 'full' | 'half'; direction: 'left' | 'right' },
  theme: Theme
): {
  [key: string]: SxProps;
} => {
  return {
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateAreas: `
        'media' 
        'content'
      `,
      gap: theme.spacing(5),
      [theme.breakpoints.up('lg')]: {
        gap: theme.spacing(9),
        gridTemplateColumns: '1fr 1fr',
        gridTemplateAreas: direction === 'left' ? "'content media'" : "'media content'",
      },
    },
    media: {
      gridArea: 'media',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      [theme.breakpoints.down('lg')]: {
        padding: theme.spacing(5),
      },
      alignItems: 'center',
    },
    content: {
      gridArea: 'content',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr repeat(2, min-content) 1fr',
    },
    text: {
      gridRow: '2 / 3',
    },
    button: {
      gridRow: '3 / 4',
      marginTop: DEFAULT_MARGIN_NORMAL,
      paddingLeft: DEFAULT_MARGIN_TEXT,
    },
  };
};
